export default __webpack_public_path__ + "static/media/deepdraw.49a2ac2b.jpg";